export const ADVISORY_ROLES = [
  'admin',
  'advisor',
  'manager'
]
